import { useContext, useMemo } from 'react'

import { useSelector } from 'react-redux'

import { MaccsInternshipModalContext } from '../../../Providers/Forms/MaccsInternshipModal/MaccsInternshipModal'
import { MaccsInternship } from '../../../utils/entities/maccsInternship'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { isObject } from '../../../utils'
import { isSchoolMaccsUser } from '../../../utils/roles'
import { selectUser } from '../../../reducers/UserReducer'

const NO_SCHOOL_TEXT = 'Without school'
const NO_INSTITUTION_TEXT = 'Without institution'
const NO_STUDENT_TEXT = 'Without student'
const NO_SPECIALITY = 'Without speciality'

const MaccsInternshipCard = ({ disable, internship, refresh }) => {
  const { setData } = useContext(MaccsInternshipModalContext)

  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const className = useMemo(() => {
    let className = 'pdl-8 bdr-rds-8'

    if (!disable) {
      className += ' cu-ptr'
    }

    return className
  }, [disable])

  const textualData = useMemo(() => {
    const textualData = {
      school: isObject(internship.school) ? internship.school.name : t(NO_SCHOOL_TEXT),
      institution: isObject(internship.institution) ? internship.institution.name : t(NO_INSTITUTION_TEXT),
      assistant: isObject(internship.assistant) ? `${internship.assistant.lastname} ${internship.assistant.firstname}` : t(NO_STUDENT_TEXT),
      speciality: isObject(internship.speciality) ? internship.speciality.abbreviation : t(NO_SPECIALITY),
      workingRegime: isObject(internship.workingRegime) ? t(internship.workingRegime.name) : t('Without working regime')
    }

    if (isObject(internship.assistant) && isObject(internship.assistant.schoolSpeciality)) {
      textualData.assistant += ` - ${internship.assistant.schoolSpeciality.specialityYear.specialityAbbreviation} (${internship.assistant.schoolSpeciality.specialityYear.studyYearName})`
    }

    return textualData
  }, [internship.school, internship.institution, internship.assistant, internship.speciality, t])

  const handleClick = () => {
    if (!disable) {
      setData({ object: new MaccsInternship(internship), callback: refresh })
    }
  }

  return (
    <div className='maccs-internship-card' onClick={handleClick}>
      <div className={className}>
        <div style={{ height: '25px', lineHeight: '25px', display: 'flex' }}>
          <span style={{ width: '70%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            <b> {textualData.assistant} </b>
          </span>
          <span className='text-ellipsis' style={{ width: '30%' }}> {textualData.workingRegime}</span>
        </div>
        <div style={{ height: '25px', lineHeight: '25px', display: 'flex' }}>
          <span style={{ width: '70%', maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {isSchoolMaccsUser(user) ? textualData.institution : textualData.school}
          </span>
          <span className='text-ellipsis' style={{ width: '30%' }}> {textualData.speciality}</span>
        </div>
      </div>
    </div>
  )
}

export default MaccsInternshipCard
